import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'despesa/cadastro/transportadora', ptBr);
i18next.addResourceBundle('en', 'despesa/cadastro/transportadora', en);

const TransportadoraConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/suprimentos/transportadora',
      component: React.lazy(() => import('./Transportadora')),
    },
  ],
};

export default TransportadoraConfig;
